(() => {
  const DAY = 86400000;
  const GTA_CITIES = new Set(['toronto','north york','scarborough','etobicoke','east york','york','mississauga','brampton','caledon','bolton','caledon east','oakville','burlington','milton','halton hills','georgetown','acton','vaughan','woodbridge','maple','concord','thornhill','richmond hill','markham','unionville','stouffville','whitchurch stouffville','aurora','newmarket','east gwillimbury','holland landing','sharon','mount albert','georgina','keswick','sutton','king','king city','nobleton','schomberg','ajax','pickering','whitby','brooklin','oshawa','clarington','bowmanville','courtice','newcastle','uxbridge','scugog','port perry','brock','beaverton','cannington']);
  const SOUTHERN_ONTARIO_CITIES = new Set([...GTA_CITIES, ..."hamilton|stoney creek|dundas|ancaster|waterdown|flamborough|binbrook|grimsby|beamsville|lincoln|west lincoln|smithville|niagara falls|niagara on the lake|st catharines|saint catharines|thorold|welland|pelham|fonthill|port colborne|fort erie|ridgeway|wainfleet|kitchener|waterloo|cambridge|guelph|burlington|brantford|brant|paris|st george|ayr|new hamburg|wilmot|wellesley|woolwich|elmira|elora|fergus|centre wellington|erin|rockwood|puslinch|orangeville|shelburne|grand valley|dufferin|caledonia|cayuga|dunnville|haldimand|simcoe|port dover|delhi|waterford|norfolk|tillsonburg|woodstock|ingersoll|oxford|london|st thomas|saint thomas|aylmer|strathroy|mount brydges|lucan|ilderton|dorchester|komoka|sarnia|petrolia|forest|grand bend|lambton shores|stratford|st marys|saint marys|listowel|mitchell|stirling|exeter|goderich|clinton|wingham|walkerton|hanover|durham|mount forest|harriston|palmerston|arthur|owen sound|meaford|thornbury|the blue mountains|collingwood|wasaga beach|stayner|creemore|shelburne|dundalk|flesherton|markdale|chesley|paisley|port elgin|southampton|sauble beach|wiarton|tobermory|kincardine|lucknow|windsor|lasalle|tecumseh|lakeshore|essex|amherstburg|kingsville|leamington|harrow|belle river|chatham|chatham kent|wallaceburg|blenheim|ridgetown|tilbury|dresden|bothwell|barrie|innisfil|bradford|bradford west gwillimbury|alliston|new tecumseth|beeton|tottenham|angus|essa|orillia|oro medonte|midland|penetanguishene|tiny|tay|victoria harbour|coldwater|elmvale|springwater|severn|washago|gravenhurst|bracebridge|huntsville|muskoka|muskoka lakes|bala|port carling|baysville|dwight|dorset|parry sound|severn bridge|burks falls|sundridge|south river|kearney|magnetawan|peterborough|kawartha lakes|lindsay|bobcaygeon|fenelon falls|coboconk|omemee|millbrook|cavan monaghan|lakefield|selwyn|havelock|norwood|campbellford|trenton|quinte west|belleville|brighton|cobourg|port hope|colborne|grafton|bancroft|haliburton|minden|apsley|tweed|madoc|marmora|deseronto|napanee|greater napanee|picton|prince edward county|wellington|bloomfield|kingston|gananoque|brockville|prescott|cornwall|smiths falls|perth|carleton place|almonte|mississippi mills|arnprior|renfrew|pembroke|petawawa|deep river|eganville|barrys bay|killaloe|ottawa|kanata|nepean|orleans|gloucester|stittsville|manotick|osgoode|greely|richmond|carp|constance bay|kemptville|north grenville|russell|embrun|casselman|rockland|clarence rockland|hawkesbury|alexandria|vankleek hill|winchester|chesterville|morrisburg|ingleside|long sault".split('|')]);
  const dateKey = date => date.toISOString().slice(0, 10);
  const plusDays = (date, days) => new Date(date.getTime() + days * DAY);
  const cleanName = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();
  const parseDates = value => new Set(String(value || '').split(/[\s,;]+/).filter(x => /^\d{4}-\d{2}-\d{2}$/.test(x)));

  const torontoFormatter = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
  function torontoClock(now) {
    const parts = Object.fromEntries(torontoFormatter.formatToParts(now).map(part => [part.type, part.value]));
    return { date: new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), 12)), hour: Number(parts.hour), minute: Number(parts.minute), second: Number(parts.second) };
  }

  function locationFromGeo(data) {
    const country = String(data?.country_code || '').toUpperCase();
    const city = String(data?.city || '').trim().slice(0, 80);
    const province = cleanName(data?.region);
    const latitude = Number.parseFloat(data?.latitude);
    const longitude = Number.parseFloat(data?.longitude);
    const inSouthernArea = Number.isFinite(latitude) && Number.isFinite(longitude)
      && latitude >= 41.5 && latitude < 46 && longitude >= -83.5 && longitude <= -74
      && !(latitude > 45.5 && longitude < -80.5);
    const local = country === 'CA' && ['ontario', 'on'].includes(province)
      && (SOUTHERN_ONTARIO_CITIES.has(cleanName(city)) || inSouthernArea);
    return { region: local ? 'GTA' : country, city, province: String(data?.region || '').slice(0, 80), source: 'ip' };
  }

  function locationFromAddress(address = {}) {
    const country = String(address.countryCode || address.country_code || address.country || '').toUpperCase();
    const province = String(address.province || address.province_code || '').trim();
    const postal = String(address.postal || address.zip || '').toUpperCase().replace(/\s/g, '');
    const city = String(address.city || '').trim().slice(0, 80);
    const validPostal = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z]\d[ABCEGHJ-NPRSTV-Z]\d$/.test(postal);
    const ontario = /^(ON|Ontario)$/i.test(province) || (validPostal && /^[KLMNP]/.test(postal));
    const localPostal = validPostal && (/^[KLMN]/.test(postal) || /^(P0A|P0B|P0C|P0E|P1H|P1L|P1P|P2A)/.test(postal));
    const local = country === 'CA' && ontario && (validPostal ? localPostal : SOUTHERN_ONTARIO_CITIES.has(cleanName(city)));
    return { region: local ? 'GTA' : country, province: ontario ? 'Ontario' : province, city,
      postal: validPostal ? postal.slice(0, 3) + ' ' + postal.slice(3) : postal, source: 'address' };
  }

  function cutoffCountdown(now, cutoff = 18) {
    const clock = torontoClock(now);
    const minutes = Math.max(0, Number(cutoff) * 60 - clock.hour * 60 - clock.minute);
    return { hours: Math.floor(minutes / 60), minutes: minutes % 60, remaining: minutes };
  }

  function cutoffClock(now, cutoff = 18) {
    const clock = torontoClock(now);
    const seconds = Math.max(0, cutoff * 3600 - clock.hour * 3600 - clock.minute * 60 - clock.second);
    return { seconds, text: [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(value => String(value).padStart(2, '0')).join(':') };
  }

  function provinceFromPostal(postal) {
    const first = String(postal || '').trim().toUpperCase()[0];
    return ({ A: 'Newfoundland and Labrador', B: 'Nova Scotia', C: 'Prince Edward Island', E: 'New Brunswick',
      G: 'Quebec', H: 'Quebec', J: 'Quebec', K: 'Ontario', L: 'Ontario', M: 'Ontario', N: 'Ontario', P: 'Ontario',
      R: 'Manitoba', S: 'Saskatchewan', T: 'Alberta', V: 'British Columbia', Y: 'Yukon' })[first] || '';
  }

  function deliveryEstimate(now, region, options = {}) {
    const clock = torontoClock(now), gtaClosures = parseDates(options.gtaClosedDates);
    const cutoff = Math.min(23, Math.max(0, Number(options.cutoff ?? 18)));
    if (region === 'GTA') {
      const closedToday = gtaClosures.has(dateKey(clock.date));
      const before = clock.hour < cutoff && !closedToday;
      let arrival = plusDays(clock.date, before ? 1 : 2);
      for (let guard = 0; gtaClosures.has(dateKey(arrival)) && guard < 60; guard++) arrival = plusDays(arrival, 1);
      return { kind: 'gta', start: arrival, end: arrival, tomorrow: arrival.getTime() === plusDays(clock.date, 1).getTime(), cutoff, cutoffState: closedToday ? 'closed' : before ? 'before' : 'after' };
    }
    return { kind: ['CA', 'US'].includes(region) ? 'carrier' : 'unknown' };
  }

  // Dates returned by Shopify already include the carrier's delivery calculation.
  // Never add theme processing/transit days to them.
  function carrierDate(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
    const date = new Date(value + 'T12:00:00Z');
    return Number.isFinite(date.getTime()) && dateKey(date) === value ? date : null;
  }

  function carrierEstimates(rates, now = new Date()) {
    const today = torontoClock(now).date;
    return (Array.isArray(rates) ? rates : []).map(rate => {
      const range = Array.isArray(rate.delivery_range) ? rate.delivery_range : [];
      let start = carrierDate(range[0]), end = carrierDate(range[1]);
      if (!start || !end || end < start) start = end = carrierDate(rate.delivery_date);
      if (start && start < today) start = end = null;
      const price = rate.price === null || rate.price === undefined || String(rate.price).trim() === '' ? NaN : Number(rate.price);
      return { name: String(rate.presentment_name || rate.name || '').slice(0, 160), price, currency: rate.currency, start, end };
    }).filter(rate => rate.name);
  }

  function quoteAddress(region, province, postal) {
    const zip = String(postal || '').trim().toUpperCase();
    if (region === 'CA' || region === 'GTA') {
      const compact = zip.replace(/\s/g, '');
      if (!/^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z]\d[ABCEGHJ-NPRSTV-Z]\d$/.test(compact)) return null;
      return province ? { country: 'Canada', province, zip: compact.slice(0, 3) + ' ' + compact.slice(3) } : null;
    }
    if (region === 'US' && /^\d{5}(-\d{4})?$/.test(zip) && province) return { country: 'United States', province, zip };
    return null;
  }

  function shippingState(variant, quantity = 1) {
    if (!variant?.shipping) return 'not-shipped';
    if (!variant.available) return 'unavailable';
    if (!variant.readyToShip || (variant.stockForEstimate !== null && Number(variant.stockForEstimate) < quantity)) return 'backorder';
    return 'ready';
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { torontoClock, locationFromGeo, deliveryEstimate, shippingState, carrierDate, carrierEstimates, quoteAddress, locationFromAddress, cutoffCountdown, cutoffClock, provinceFromPostal };
    return;
  }
  if (customElements.get('sf-delivery-estimate')) return;
  const configElement = document.getElementById('sf-delivery-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent), labels = config.labels;
  const ZONE_VERSION = 6;
  const CACHE_KEY = 'sf-delivery-destination-v1', TTL = 4 * 60 * 60 * 1000;
  const subscribers = new Set();
  const words = (text, values = {}) => String(text || '').replace(/\[([a-z]+)\]/g, (_, key) => values[key] ?? '');
  const knownAddress = config.address?.countryCode ? locationFromAddress(config.address) : null;
  let locationState = knownAddress?.postal ? knownAddress : { region: config.country || '', city: '', source: 'market' }, saved;
  try { saved = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null'); } catch (_) {}
  if (saved && saved.source === 'manual' && Date.now() - saved.timestamp < TTL && ['GTA', 'CA', 'US'].includes(saved.region)) locationState = { region: saved.region, city: String(saved.city || '').slice(0, 80), source: saved.source === 'manual' ? 'manual' : saved.city ? 'ip' : 'market', province: String(saved.province || '').slice(0, 80), postal: String(saved.postal || '').slice(0, 10) };
  function saveLocation(value) {
    locationState = value;
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ ...value, zoneVersion: ZONE_VERSION, timestamp: Date.now() })); } catch (_) {}
    subscribers.forEach(component => { component.quoteKey = ''; component.quote = null; component.render(); });
  }
  if (!knownAddress?.postal && locationState.source === 'market') {
    let cachedCountry;
    try { cachedCountry = JSON.parse(sessionStorage.getItem('sf-ip-country') || 'null'); } catch (_) {}
    if (cachedCountry && Date.now() - cachedCountry.time < TTL && ['CA', 'US'].includes(cachedCountry.country)) {
      locationState = { region: cachedCountry.country, city: '', source: 'ip-country' };
    } else {
      fetch(String(config.root || '/').replace(/\/?$/, '/') + 'browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin', signal: AbortSignal.timeout(4000) })
        .then(response => response.ok ? response.json() : null).then(data => {
          const country = data?.detected_values?.country?.handle;
          if (!['CA', 'US'].includes(country) || locationState.source !== 'market') return;
          try { sessionStorage.setItem('sf-ip-country', JSON.stringify({ country, time: Date.now() })); } catch (_) {}
          saveLocation({ region: country, city: '', source: 'ip-country' });
        }).catch(() => {});
    }
  }
  function renderShippingMeters() {
    const ontario = locationState.region === 'GTA' || (locationState.region === 'CA' && /^(ON|Ontario)$/i.test(locationState.province || ''));
    document.querySelectorAll('[data-shipping-total]').forEach(meter => {
      if (meter.dataset.shippingCurrency !== 'CAD' || meter.dataset.trioShipping === 'true') return;
      if (!['CA', 'US'].includes(meter.dataset.shippingCountry)) return;
      const threshold = ontario ? 11900 : 19900;
      const total = Number(meter.dataset.shippingTotal);
      if (!Number.isFinite(total)) return;
      const remaining = Math.max(0, threshold - total);
      const amount = new Intl.NumberFormat(config.locale || 'en', { style: 'currency', currency: 'CAD', currencyDisplay: 'code' }).format(remaining / 100);
      const label = remaining ? (ontario ? meter.dataset.shippingRemainingOn : meter.dataset.shippingRemaining) : (ontario ? meter.dataset.shippingMetOn : meter.dataset.shippingMet);
      const message = meter.querySelector('[data-shipping-message]');
      if (message && label) message.textContent = words(label, { amount });
      const progress = meter.querySelector('progress');
      if (progress) { progress.max = threshold; progress.value = Math.min(total, threshold); }
    });
  }

  const prettyDate = date => new Intl.DateTimeFormat(config.locale || 'en', { month: 'short', day: 'numeric', timeZone: 'UTC' }).format(date);
  const prettyTime = hour => new Intl.DateTimeFormat(config.locale || 'en', { hour: 'numeric', timeZone: 'UTC' }).format(new Date(Date.UTC(2026, 0, 1, hour)));

  const quoteCache = new Map();
  let quoteQueue = Promise.resolve();
  let cartRevision = 0;
  const quoteRoot = String(config.root || '/').replace(/\/?$/, '/');
  const waitForRates = ms => new Promise(resolve => setTimeout(resolve, ms));
  async function cartCarrierQuote(address, variantId, quantity, signal) {
    const cartResponse = await fetch(quoteRoot + 'cart.js', { credentials: 'same-origin', cache: 'no-store', signal });
    if (!cartResponse.ok) throw new Error('cart-unavailable');
    const cart = await cartResponse.json();
    if (!cart.item_count || (variantId && cart.items.filter(item => String(item.variant_id) === variantId).reduce((sum, item) => sum + item.quantity, 0) < quantity)) return { status: 'add', rates: [] };
    const key = JSON.stringify([address, cart.currency, cart.total_price, cart.items.map(item => [item.key, item.quantity, item.final_line_price]), cartRevision, dateKey(torontoClock(new Date()).date)]);
    const cached = quoteCache.get(key);
    if (cached && Date.now() - cached.time < 5 * 60 * 1000) return cached.promise;
    const params = new URLSearchParams();
    for (const [field, value] of Object.entries(address)) params.set('shipping_address[' + field + ']', value);
    const run = async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 25000);
      try {
        const request = { credentials: 'same-origin', cache: 'no-store', signal: controller.signal };
        const prepared = await fetch(quoteRoot + 'cart/prepare_shipping_rates.json?' + params, { ...request, method: 'POST' });
        if (!prepared.ok) throw new Error('rates-unavailable');
        for (let attempt = 0; attempt < 12; attempt++) {
          const response = await fetch(quoteRoot + 'cart/async_shipping_rates.json?' + params, request);
          if (!response.ok) throw new Error('rates-unavailable');
          const data = await response.json();
          if (data && Array.isArray(data.shipping_rates)) return { status: 'ready', rates: carrierEstimates(data.shipping_rates), currency: cart.currency };
          await waitForRates(Math.min(400 + attempt * 200, 1600));
        }
        throw new Error('rates-timeout');
      } finally { clearTimeout(timeout); }
    };
    // Shopify's rate preparation belongs to the current cart: serialize destinations.
    const promise = quoteQueue.catch(() => {}).then(run);
    quoteQueue = promise;
    quoteCache.set(key, { time: Date.now(), promise });
    if (quoteCache.size > 12) quoteCache.delete(quoteCache.keys().next().value);
    try { return await promise; } catch (error) { quoteCache.delete(key); throw error; }
  }

  document.addEventListener('sf:cart-updated', () => {
    cartRevision++;
    quoteCache.clear();
    subscribers.forEach(component => { component.quoteKey = ''; component.quote = null; component.render(); });
  });

  class Delivery extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.root = this.closest('[data-product-root]');
      if (this.root) {
        this.root.addEventListener('sf:variant-updated', event => this.updateVariant(event.detail.variant), { signal });
        this.root.addEventListener('change', event => { if (event.target.matches('[name=quantity]')) this.render(); }, { signal });
        this.root.addEventListener('click', event => { if (event.target.closest('[data-quantity-delta]')) requestAnimationFrame(() => this.render()); }, { signal });
      }
      this.render(); subscribers.add(this);
      this.lastMinute = Math.floor(Date.now() / 60000);
      this.timer = setInterval(() => {
        const minute = Math.floor(Date.now() / 60000);
        if (document.hidden) return;
        if (minute !== this.lastMinute) { this.lastMinute = minute; this.render(); }
        else this.tick();
      }, 1000);
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.render(); }, { signal });
      window.addEventListener('pageshow', () => this.render(), { signal });
      if (this.closest('dialog')) {
        this.observer = new MutationObserver(() => { if (this.closest('dialog')?.open) { this.render(); } });
        this.observer.observe(this.closest('dialog'), { attributes: true, attributeFilter: ['open'] });
      }
    }
    tick() {
      const clock = this.querySelector('[data-delivery-clock]');
      if (!clock) return;
      const remaining = cutoffClock(new Date(), this.clockCutoff);
      if (!remaining.seconds) { this.render(); return; }
      if (clock.textContent !== remaining.text) clock.textContent = remaining.text;
    }
    updateVariant(variant) {
      this.dataset.variantId = String(variant.id);
      this.dataset.shipping = String(variant.shipping);
      this.dataset.available = String(variant.available);
      this.dataset.ready = String(variant.readyToShip);
      if (variant.stockForEstimate === null) delete this.dataset.stock; else this.dataset.stock = String(variant.stockForEstimate);
      this.quoteKey = ''; this.quote = null;
      this.render();
    }
    loadQuote(address, quantity) {
      if (this.closest('dialog') && !this.closest('dialog').open) return;
      const variantId = this.dataset.context === 'product' ? this.dataset.variantId : '';
      const key = JSON.stringify([address, variantId, quantity, cartRevision, Math.floor(Date.now() / 300000)]);
      if (key === this.quoteKey) return;
      this.quoteKey = key; this.quote = { status: 'loading', rates: [] };
      const requestLocation = locationState;
      cartCarrierQuote(address, variantId, quantity, this.controller.signal).then(result => {
        if (this.isConnected && this.quoteKey === key && locationState === requestLocation) { this.quote = result; this.render(); }
      }).catch(() => {
        if (this.isConnected && this.quoteKey === key && locationState === requestLocation) { this.quote = { status: 'error', rates: [] }; this.render(); }
      });
    }
    rateDate(rate) {
      return !rate.start ? labels.dateAtCheckout : rate.start.getTime() === rate.end.getTime() ? words(labels.receive, { date: prettyDate(rate.start) }) : words(labels.between, { start: prettyDate(rate.start), end: prettyDate(rate.end) });
    }
    rateName(rate) {
      if (!Number.isFinite(rate.price) || rate.price < 0) return rate.name;
      const currency = rate.currency || this.quote?.currency;
      if (!/^[A-Z]{3}$/.test(currency || '')) return rate.name;
      try {
        const price = new Intl.NumberFormat(config.locale || 'en', { style: 'currency', currency, currencyDisplay: 'code' }).format(rate.price);
        return rate.name + ' · ' + price;
      } catch (_) { return rate.name; }
    }
    render() {
      renderShippingMeters();
      const quantity = Number(this.root?.querySelector('.sf-main-add-form [name=quantity]')?.value || 1);
      const state = shippingState({ shipping: this.dataset.shipping === 'true', available: this.dataset.available === 'true', readyToShip: this.dataset.ready === 'true', stockForEstimate: this.dataset.stock === undefined ? null : Number(this.dataset.stock) }, quantity);
      this.hidden = state === 'not-shipped';
      if (this.hidden) return;
      const arrival = this.querySelector('[data-delivery-arrival]');
      const service = this.querySelector('[data-delivery-service]');
      const region = locationState.region;
      const city = String(locationState.city || '').trim();
      const near = city ? ' ' + words(labels.near, { place: city }) : '';
      this.dataset.region = region;
      service.replaceChildren();
      if (state !== 'ready') { this.quoteKey = ''; this.quote = null; arrival.textContent = state === 'unavailable' ? labels.unavailable : labels.backorder; return; }
      const conditionalLocal = region === 'CA' && ['market', 'ip-country'].includes(locationState.source);
      const now = new Date();
      const estimate = deliveryEstimate(now, conditionalLocal ? 'GTA' : region, config);
      if (estimate.kind === 'gta') {
        const title = estimate.tomorrow ? labels.tomorrowBrief : words(labels.receive, { date: prettyDate(estimate.start) });
        arrival.textContent = conditionalLocal ? (estimate.tomorrow ? labels.localOffer : title + ' · ' + labels.gta) : title + near;
        if (estimate.tomorrow && estimate.cutoffState === 'before') {
          service.append(document.createTextNode(labels.orderWithin + ' '));
          const clock = document.createElement('b'); clock.dataset.deliveryClock = '';
          this.clockCutoff = estimate.cutoff;
          clock.textContent = cutoffClock(now, estimate.cutoff).text;
          service.append(clock);
        }
        this.quoteKey = ''; this.quote = null;
      } else {
        arrival.textContent = labels.fast + near;
        const address = quoteAddress(region, locationState.province, locationState.postal);
        if (address) this.loadQuote(address, quantity);
        else { this.quoteKey = ''; this.quote = null; }
        if (this.quote?.status === 'ready') {
          const rates = [...this.quote.rates].sort((a, b) => a.price - b.price);
          if (rates[0]?.start) arrival.textContent = this.rateDate(rates[0]) + near;
        }
      }
    }
    disconnectedCallback() { this.quoteKey = ''; this.controller?.abort(); this.controller = null; clearInterval(this.timer); this.observer?.disconnect(); subscribers.delete(this); }
  }

  function renderHours(root) {
    const today = (torontoClock(new Date()).date.getUTCDay() + 6) % 7;
    const hours = String(config.hours || '').split('|');
    const readable = value => {
      const match = /^(\d{1,2}):(\d{2})-(\d{1,2}):(\d{2})$/.exec(String(value || '').trim());
      if (!match) return value || labels.closed;
      const time = (hour, minute) => new Intl.DateTimeFormat(config.locale || 'en', { hour: 'numeric', minute: Number(minute) ? '2-digit' : undefined, timeZone: 'UTC' }).format(new Date(Date.UTC(2026, 0, 1, Number(hour), Number(minute))));
      return time(match[1], match[2]) + ' – ' + time(match[3], match[4]);
    };
    root.querySelectorAll('[data-hours-day]').forEach(row => { const day = Number(row.dataset.hoursDay); row.classList.toggle('is-today', day === today); row.querySelector('[data-hours-value]').textContent = readable(hours[day]); });
    const current = root.querySelector('[data-pickup-today]');
    if (current) current.textContent = words(labels.todayHours, { hours: readable(hours[today]) });
  }

  class Pickup extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.addEventListener('click', event => {
        const opener = event.target.closest('[data-open-pickup]');
        if (opener) { const dialog = this.querySelector('dialog'); this.opener = opener; renderHours(this); if (dialog && !dialog.open) dialog.showModal(); }
        const dialog = this.querySelector('dialog');
        if (event.target.closest('[data-close-pickup]') || (dialog && event.target === dialog)) dialog?.close();
        if (event.target.closest('[data-retry-pickup]')) this.load(this.dataset.variantId);
      }, { signal });
      this.addEventListener('close', () => this.opener?.focus({ preventScroll: true }), { signal, capture: true });
      this.closest('[data-product-root]')?.addEventListener('sf:variant-updated', event => {
        this.hidden = !event.detail.variant.shipping;
        if (!this.hidden) this.load(event.detail.variant.id);
      }, { signal });
      renderHours(this);
    }
    async load(id) {
      this.dataset.variantId = String(id);
      this.request?.abort();
      const request = new AbortController(); this.request = request;
      this.classList.add('sf-pickup-loading'); this.setAttribute('aria-busy', 'true');
      const requested = String(id), timer = setTimeout(() => request.abort(), 8000);
      try {
        const url = new URL((config.root || '/') + 'variants/' + encodeURIComponent(id) + '/', location.origin);
        url.searchParams.set('section_id', 'sf-pickup-availability');
        const response = await fetch(url, { signal: request.signal, headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Pickup availability unavailable');
        const replacement = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-pickup-content]');
        if (!replacement) throw new Error('Pickup availability unavailable');
        if (this.request !== request || this.dataset.variantId !== requested || !this.isConnected) return;
        this.querySelector('dialog')?.close(); this.replaceChildren(replacement); renderHours(this);
      } catch (error) {
        if (this.request !== request || this.dataset.variantId !== requested || !this.isConnected) return;
        const fallback = document.createElement('div'); fallback.className = 'sf-pickup-card';
        const retry = document.createElement('button'); retry.type = 'button'; retry.className = 'sf-pickup-card__link'; retry.dataset.retryPickup = ''; retry.textContent = this.dataset.retryLabel;
        fallback.textContent = this.dataset.errorLabel + ' '; fallback.append(retry); this.replaceChildren(fallback);
      } finally {
        clearTimeout(timer);
        if (this.request === request) { this.classList.remove('sf-pickup-loading'); this.removeAttribute('aria-busy'); }
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; this.request?.abort(); this.querySelector('dialog')?.close(); }
  }

  customElements.define('sf-delivery-estimate', Delivery);
  customElements.define('sf-pickup', Pickup);
})();


